module.exports = __webpack_public_path__ + "res/29-img_game_bg.89ae485e140df0273469923cd5dce759.png";